export { default } from './EditVideoBlock';

export const displayName = 'Video';
